import { BankService } from "@/services";

export default {
  name: "bank-sheba",
  components: {},
  props: ["sheba", "isLast"],
  data() {
    return {
      shebaModal: false,
      isRequesting: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    openModal() {
      this.shebaModal = true;
    },

    closeModal() {
      this.shebaModal = false;
    },

    deleteSheba() {
      BankService.deleteSheba(this.sheba.address)
        .then(res => {
          this.$emit("delete", this.sheba.id);
          this.closeModal();
          this.$toast.success(res.data.message);
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    }
  },

  filters: {
    bankFormatter(value) {
      let split = value?.split("");
      const indexes = [4, 9, 14, 19, 24, 29];
      indexes.forEach(index => {
        split?.splice(index, 0, " ");
      });
      return split?.join("");
    }
  }
};
